export { Switcher } from '~/InfoCard/Details/Switcher';
export { PeriodButtons } from '~/InfoCard/Details/PeriodButtons';
export { Details } from '~/InfoCard/Details/Details';
export { Monthly } from '~/InfoCard/Details/Monthly';
export { MonthlyMultiValue } from '~/InfoCard/Details/MonthlyMultiValue';
export { OrdersInRegister } from '~/InfoCard/Details/OrdersInRegister';
export { OrderPackages } from '~/InfoCard/Details/OrderPackages';
export { DateStatistics } from '~/InfoCard/Details/DateStatistics';
export { IndicationRestrictionPayment } from '~/InfoCard/Details/IndicationRestrictionPayment';
export { CompanyPayments } from '~/InfoCard/Details/CompanyPayments';
export { PositiveList } from '~/InfoCard/Details/PositiveList';
export { Packages } from '~/InfoCard/Details/Packages';
export { UnitPrice } from '~/InfoCard/Details/UnitPrice';
export { OtherLink } from '~/InfoCard/Details/OtherLink';
export { MonthlyPackageBalance } from '~/InfoCard/Details/MonthlyPackageBalance';
export { MonthlyDistrictBalance } from '~/InfoCard/Details/MonthlyDistrictBalance';
export { Period, PeriodType, PeriodAction } from '~/InfoCard/Details/Period';
